const initBlock = async function( $block ) {
	const ServicesMapModule = await import( '../modules/services-map' );
	const ServicesMap = ServicesMapModule.default;
	const servicesMapInstance = new ServicesMap( $block );
	await servicesMapInstance.init();
};

app.loadBlock( initBlock, 'services-map', '.section-services-map' );

if ( module.hot ) {
	module.hot.accept();
}
